// Shared formatting code between React & Handlebars templates which display proposal message feeds
window.proposalMessageFormatter = {};

// This can be made a module once helpers.js is in Rollup
window.proposalMessageFormatter.getLocationAndDonorTeacherRelationship = function (location, donorTeacherRelationship, commaAfterDonorTeacherRelationship = true) {
    let result = '';
    if (location && location.trim() !== '') {
        result += ' from ' + location;
    }
    if (donorTeacherRelationship && donorTeacherRelationship.trim() !== '') {
        result += ', a ' + donorTeacherRelationship;
        if (commaAfterDonorTeacherRelationship) {
            result += ',';
        }
    }
    return result;
};
